import { RevealLines, Reveal } from "@/components/common/Reveal";

export function PageHero({ eyebrow, lines, sub, image, children }) {
  return (
    <section className="relative pt-40 pb-20 sm:pt-48 sm:pb-24 overflow-hidden" data-testid="page-hero">
      <div className="absolute inset-0 z-0">
        {image && <img src={image} alt="" className="h-full w-full object-cover opacity-20" />}
        <div className="absolute inset-0 bg-gradient-to-b from-[#07080B]/70 via-[#07080B]/90 to-[#07080B]" />
        <div className="absolute inset-0 radial-gold" />
      </div>
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
        {eyebrow && (
          <div className="eyebrow mb-6 flex items-center gap-3">
            <span className="h-px w-10 bg-[var(--gold)]/70" />
            {eyebrow}
          </div>
        )}
        <h1 className="font-serif font-light tracking-tight leading-[1.04] text-4xl sm:text-6xl lg:text-7xl text-white max-w-4xl">
          <RevealLines lines={lines} />
        </h1>
        {sub && (
          <Reveal delay={0.3}>
            <p className="mt-7 max-w-2xl text-base sm:text-lg text-slate-300 font-light leading-relaxed">{sub}</p>
          </Reveal>
        )}
        {children && <Reveal delay={0.4}><div className="mt-9">{children}</div></Reveal>}
      </div>
    </section>
  );
}
